module.exports = __webpack_public_path__ + "static/media/logoWhite.2541c876.png";